import Styles from './ShareSheetItem.module.scss'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Text } from 'blaze-ui/Text/Text'
import cx from 'classnames'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { ReactNode } from 'react'

export type ShareSheetItemProps = {
  icon: React.ReactNode
  title: string
  onClick: () => void
  description: ReactNode
  action?: React.ReactNode
  fullWidth?: boolean
  halfWidth?: boolean
  extra?: React.ReactNode
}

export const ShareSheetItem: React.FC<ShareSheetItemProps> = ({
  icon,
  title,
  onClick,
  description,
  extra,
  action,
  fullWidth = false,
  halfWidth = false,
}) => {
  const { isMobile } = useResponsiveDesign()

  return (
    <div
      className={cx(Styles.container, { [Styles.fullWidth]: fullWidth, [Styles.halfWidth]: halfWidth })}
      onClick={onClick}
    >
      <div className={Styles.top}>
        <div className={Styles.icon}>{icon}</div>
        {extra && <div className={Styles.extra}>{extra}</div>}
      </div>
      <div className={Styles.body}>
        <div className={Styles.details}>
          {isMobile ? (
            <Text variant="smallList" color="var(--dark-80)">
              {title}
            </Text>
          ) : (
            <Heading level={5} color="var(--dark-80)">
              {title}
            </Heading>
          )}
          <Text variant={isMobile ? 'metadata' : 'secondary'} color="var(--dark-60)">
            {description}
          </Text>
        </div>
        {action && <div className={Styles.action}>{action}</div>}
      </div>
    </div>
  )
}
